// The copy-paste call shown beside the landing demo and on every country page.
//
// It is one constant because it is one command. The snippet a visitor copies
// has to be the command the documentation teaches, and while the two lived
// apart the landing one drifted into something that cannot be run: it carried
// a literal `<base64-encoded JPEG or PNG>` placeholder, so pasting it answered
// 422 — from the call that is supposed to be the first thing that works.
//
// The source is the quick-start's curl example in
// apps/docs/content/start/first-recognition.md, and ./curl.test.ts holds this
// to it: the docs example is executed against a live instance by the
// docs-examples suite, so pinning to it is what makes this runnable rather
// than merely plausible.

import { API_HOST, SANDBOX_PUBLIC_KEY } from "$lib/seo/site";

// Reads `document.jpg` from the directory the command is run in and sends it
// base64-encoded, with the newlines `base64` inserts stripped. Raw because
// every backslash in it is a shell escape rather than a JavaScript one.
export const CURL_IMAGE_BODY = String.raw`-d "{\"image\": \"$(base64 < document.jpg | tr -d '\n')\"}"`;

/** The sandbox recognition call, exactly as a visitor can paste it. */
export const SANDBOX_CURL = `curl -X POST ${API_HOST}/v1/scans \\
  -H "Authorization: Bearer ${SANDBOX_PUBLIC_KEY}" \\
  -H "Content-Type: application/json" \\
  ${CURL_IMAGE_BODY}`;
